import { useEffect, useState } from "react";
import "./styles.css";

const UkPhoneInput = ({ value, handleChange, disabled, id }) => {
  const formatNumber = (phone) => {
    if (phone.length < 3) return "+44";

    if (isNaN(phone.slice(1).replaceAll(" ", ""))) return;

    if (phone.length > 3 && phone[3] !== " ") {
      phone = phone.slice(0, 3) + " " + phone.slice(3);
    }

    if (phone.length > 8 && phone[8] !== " ") {
      phone = phone.slice(0, 8) + " " + phone.slice(8);
    }

    return phone;
  };

  const [formatted, setFormatted] = useState(
    value ? formatNumber(`+${value}`) : "+44"
  );

  useEffect(() => {
    if (formatted) {
      let rawPhone = formatted.replace();

      while (rawPhone.includes(" ")) rawPhone = rawPhone.replace(" ", "");

      rawPhone = rawPhone.replace("+", "");

      if (rawPhone.slice(0, 3) === "440") {
        rawPhone = rawPhone.slice(0, 2) + rawPhone.slice(3);
      }

      handleChange(rawPhone, true);
    }
  }, [formatted]);

  const [maxLength, setMaxLength] = useState(15);

  useEffect(() => {
    if (formatted && formatted.slice(0, 5) === "+44 0") {
      setMaxLength(16);
    } else {
      setMaxLength(15);
    }
  }, [formatted]);

  const onPhoneChange = (e) => {
    let phone = e.target.value;

    if (phone.length < 3) return;

    if (isNaN(phone.slice(1).replaceAll(" ", ""))) return;

    if (phone.length > 3 && phone[3] !== " ") {
      phone = phone.slice(0, 3) + " " + phone.slice(3);
    }

    if (phone.length > 8 && phone[8] !== " ") {
      phone = phone.slice(0, 8) + " " + phone.slice(8);
    }

    setFormatted(phone);
  };

  return (
    <input
      type="text"
      id={id}
      className="form-control"
      maxLength={maxLength}
      value={formatted}
      onChange={onPhoneChange}
      disabled={disabled}
      required
    />
  );
};

export default UkPhoneInput;
